module.exports = __webpack_public_path__ + "img/85.9b55720c.gif";